module.exports = __webpack_public_path__ + "media/images/hero_image-cf4ae81b0c60453897017b35e1b4e126.jpg";